module.exports = __webpack_public_path__ + "static/media/logo.51e7b083.png";